import { fallbackTexts } from '@/constants';
import { IconTiny } from '@/widgets/components/icon';
import lockOutlined from '@iconify/icons-ant-design/lock-outlined';

export function validateAddress(address) {
  // TODO: Remove string comparison when more comprehensive testing has been developed
  // Need to do a 'null' string comparison for popup card APN and address values
  //  when hovering over unidentified properties on the map
  if (Boolean(address) && address !== 'null') return address;
  return fallbackTexts.PENDING_IDENTIFICATION;
}

/**
 * Returns either a lock symbol or the relevant data to be shown to user
 * @param {Boolean} isContentHidden flag to determine if content is hidden
 * @param {Function} cb callback function to retrieve necessary data to show
 * @param {*} cbArgs arguments to callback
 */
export function hideData(isContentHidden, cb, ...cbArgs) {
  if (isContentHidden) {
    return <IconTiny icon={lockOutlined} />;
  }

  return cb(...cbArgs);
}
